// extracted by mini-css-extract-plugin
export default {"inputsRow":"YearInputs_inputsRow__vHttC","inputGroup":"YearInputs_inputGroup__HICv-","inputDash":"YearInputs_inputDash__PSifs","yearInput":"YearInputs_yearInput__MPOC7"};